export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', description: '浏览所有韩国漫画作品' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '浪漫甜蜜的恋爱韩漫' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', description: '热血刺激的动作漫画' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑故事' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的搞笑韩漫' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '引人入胜的剧情佳作' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画' },
];

export const comics = [
  {
    id: 1,
    title: '我的野蛮女友',
    titleEn: 'My Sassy Girl',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20webtoon%20cover%20featuring%20a%20young%20couple%20in%20Seoul%20cityscape%20at%20sunset%2C%20warm%20golden%20lighting%2C%20soft%20watercolor%20illustration%20style%2C%20romantic%20atmosphere%2C%20clean%20composition%2C%20pastel%20color%20palette%2C%20Korean%20manhwa%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一个平凡的大学生与性格火爆的女友之间发生的甜蜜又搞笑的故事。两人从相识到相爱，经历了无数令人捧腹又感动的瞬间。',
    author: '金允熙',
    status: '连载中',
    chapters: 128,
    rating: 9.2,
    views: 2850000,
    tags: ['恋爱', '搞笑', '校园', '日常'],
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    longDescription: '《我的野蛮女友》是韩国漫画家金允熙的代表作，讲述了普通大学生李贤宇与性格强势的校花姜秀雅之间发生的一系列故事。作品以轻松幽默的笔触描绘了当代年轻人的恋爱观，既有令人捧腹的搞笑桥段，也有触动心弦的温情时刻。作者细腻的画风和生动的对白让角色栩栩如生，让读者仿佛亲历主人公的喜怒哀乐。自连载以来，该作品在各大平台累计阅读量突破285万，成为近年来最受欢迎的韩国恋爱漫画之一。',
    chapters_list: Array.from({ length: 128 }, (_, i) => ({
      num: 128 - i,
      title: `第${128 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
  },
  {
    id: 2,
    title: '剑与魔法',
    titleEn: 'Sword & Magic',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20cover%20showing%20a%20warrior%20with%20glowing%20sword%20facing%20a%20dragon%20in%20epic%20battle%2C%20dramatic%20lighting%20with%20blue%20and%20gold%20sparks%2C%20dynamic%20composition%2C%20detailed%20illustration%2C%20Korean%20manhwa%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个魔法与剑并存的世界里，少年剑士踏上寻找传说之剑的冒险旅程，途中结识了各具特色的伙伴。',
    author: '朴志勋',
    status: '连载中',
    chapters: 96,
    rating: 9.5,
    views: 4120000,
    tags: ['奇幻', '冒险', '战斗', '热血'],
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
    longDescription: '《剑与魔法》是韩国顶尖奇幻漫画家朴志勋倾力打造的史诗级作品。故事设定在一个剑与魔法共存的大陆，主人公艾伦是一名失去记忆的少年剑士，为了寻找传说中的"星辰之剑"踏上了冒险之旅。在这个世界中，他结识了精灵弓箭手莉娜、矮人铁匠索林和神秘魔法师艾琳，四人组成的小队共同对抗黑暗势力的入侵。作品以其宏大的世界观、细腻的画风和紧凑的剧情获得了读者的一致好评，累计阅读量已突破412万。',
    chapters_list: Array.from({ length: 96 }, (_, i) => ({
      num: 96 - i,
      title: `第${96 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
  },
  {
    id: 3,
    title: '暗夜追踪者',
    titleEn: 'Night Tracker',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20webtoon%20cover%20featuring%20a%20mysterious%20detective%20in%20trench%20coat%20standing%20in%20rainy%20Seoul%20alley%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20Korean%20manhwa%20art%20style&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '前特种部队成员化身都市暗夜追踪者，打击犯罪集团的故事。紧张刺激的打斗场面和悬疑剧情交织。',
    author: '李正宇',
    status: '已完结',
    chapters: 64,
    rating: 9.0,
    views: 1680000,
    tags: ['动作', '悬疑', '都市', '犯罪'],
    updateDate: '2026-07-15',
    isHot: false,
    isNew: false,
    isRecommended: true,
    longDescription: '《暗夜追踪者》讲述了前特种部队成员林泰俊在退役后回到首尔，目睹挚友被犯罪集团杀害后，化身为都市暗夜中的正义执行者。白天他是一名普通的快递员，夜晚则追踪犯罪分子的踪迹。作品以紧凑的剧情、逼真的打斗场景和对都市黑暗面的深刻描绘著称。作者李正宇凭借此作荣获2025年韩国漫画大赏最佳动作漫画奖。全64话已完结，是韩国动作漫画的经典之作。',
    chapters_list: Array.from({ length: 64 }, (_, i) => ({
      num: 64 - i,
      title: `第${64 - i}话`,
      date: `2026-${String(Math.max(1, 7 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 20))).padStart(2, '0')}`,
    })),
  },
  {
    id: 4,
    title: '第七个目击者',
    titleEn: 'The Seventh Witness',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20thriller%20Korean%20webtoon%20cover%20with%20seven%20silhouetted%20figures%20standing%20in%20a%20circle%20under%20a%20single%20spotlight%2C%20dark%20atmosphere%2C%20mysterious%20mood%2C%20minimalist%20composition%2C%20Korean%20manhwa%20thriller%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '一起离奇的谋杀案，七个各怀秘密的目击者。每个人都说自己看到了真相，但真相只有一个。',
    author: '崔恩珠',
    status: '连载中',
    chapters: 42,
    rating: 9.7,
    views: 3200000,
    tags: ['悬疑', '推理', '犯罪', '心理'],
    updateDate: '2026-08-04',
    isHot: true,
    isNew: true,
    isRecommended: true,
    longDescription: '《第七个目击者》是韩国新生代漫画家崔恩珠的悬疑力作。故事以一栋公寓楼内发生的离奇死亡事件为开端，案件有七名目击者，每个人都声称看到了不同的"真相"。刑警韩智浩在调查过程中逐渐发现，这七个人都与死者有着不为人知的联系。作品巧妙运用多视角叙事手法，每话从一个目击者的角度展开，让读者随着剧情推进不断推翻之前的推测。精妙的布局和出人意料的转折使该作品成为韩国悬疑漫画的新标杆。',
    chapters_list: Array.from({ length: 42 }, (_, i) => ({
      num: 42 - i,
      title: `第${42 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 10))).padStart(2, '0')}-${String(Math.max(1, 25 - (i % 10))).padStart(2, '0')}`,
    })),
  },
  {
    id: 5,
    title: '社长大人请自重',
    titleEn: 'Mr. President, Behave',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20romantic%20comedy%20Korean%20webtoon%20cover%20showing%20a%20handsome%20CEO%20in%20suit%20being%20teased%20by%20a%20cute%20female%20employee%20in%20office%2C%20bright%20pastel%20colors%2C%20playful%20mood%2C%20chibi%20expression%2C%20Korean%20manhwa%20comedy%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '霸道总裁遇上鬼马女职员，办公室里的搞笑日常。每天都有意想不到的爆笑事件发生。',
    author: '尹美莱',
    status: '连载中',
    chapters: 156,
    rating: 8.8,
    views: 5200000,
    tags: ['搞笑', '恋爱', '职场', '日常'],
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: false,
    longDescription: '《社长大人请自重》是漫画家尹美莱创作的办公室搞笑漫画。故事围绕新入职的菜鸟员工郑多恩与完美主义社长车敏俊展开。郑多恩凭借乐观开朗的性格和出其不意的脑回路，一次次打破社长精心维护的高冷形象。作品以夸张幽默的表现手法和温暖人心的职场故事赢得了大量读者的喜爱，在搞笑类韩漫中长期占据榜首位置。',
    chapters_list: Array.from({ length: 156 }, (_, i) => ({
      num: 156 - i,
      title: `第${156 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 40))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 40))).padStart(2, '0')}`,
    })),
  },
  {
    id: 6,
    title: '重生之逆袭人生',
    titleEn: 'Reborn Revenge',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20webtoon%20cover%20of%20rebirth%20theme%2C%20a%20determined%20protagonist%20looking%20at%20city%20skyline%20from%20rooftop%20at%20dawn%2C%20dramatic%20golden%20sunrise%20light%2C%20powerful%20composition%2C%20Korean%20manhwa%20drama%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '被陷害致死的商业天才重生回到十年前，这一次他要改变命运，让所有背叛他的人付出代价。',
    author: '姜贤宇',
    status: '连载中',
    chapters: 88,
    rating: 9.4,
    views: 6800000,
    tags: ['剧情', '重生', '商战', '复仇'],
    updateDate: '2026-08-04',
    isHot: true,
    isNew: false,
    isRecommended: true,
    longDescription: '《重生之逆袭人生》是韩国漫画家姜贤宇的顶尖剧情作品。主人公金道允是韩国最大财团的天才战略顾问，因发现集团内部的惊天阴谋而被最信任的兄弟和未婚妻联手陷害致死。然而命运给了他第二次机会——他重生回到了十年前，一切悲剧尚未发生之时。带着前世记忆的金道允开始了一场精密的复仇与逆袭之旅。作品以其严密的商战逻辑、丰富的人物刻画和令人上瘾的剧情节奏，成为韩国剧情类漫画的现象级作品。',
    chapters_list: Array.from({ length: 88 }, (_, i) => ({
      num: 88 - i,
      title: `第${88 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 25))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 25))).padStart(2, '0')}`,
    })),
  },
  {
    id: 7,
    title: '幽灵教室',
    titleEn: 'Ghost Classroom',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20webtoon%20cover%20of%20haunted%20school%20classroom%20at%20night%2C%20ghostly%20figure%20in%20school%20uniform%2C%20eerie%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20Korean%20manhwa%20horror%20style%2C%20creepy%20but%20artistic&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '一所废弃学校的深夜教室里，总是传出诡异的声响。七个学生决定一探究竟，却发现了一个关于学校的恐怖秘密。',
    author: '文彩媛',
    status: '已完结',
    chapters: 36,
    rating: 9.1,
    views: 1450000,
    tags: ['恐怖', '校园', '灵异', '悬疑'],
    updateDate: '2026-06-20',
    isHot: false,
    isNew: false,
    isRecommended: false,
    longDescription: '《幽灵教室》是韩国恐怖漫画作家文彩媛的代表作。故事取材于韩国多所废弃学校的都市传说，讲述了七名高中生为探寻校园灵异事件的真相，在深夜潜入废弃教学楼后遭遇的一系列超自然事件。作品营造了极强的恐怖氛围，同时融入了对韩国教育体制的反思，使得恐怖之外多了一层社会意义。全36话已完结，是韩国恐怖漫画中不可多得的佳作。',
    chapters_list: Array.from({ length: 36 }, (_, i) => ({
      num: 36 - i,
      title: `第${36 - i}话`,
      date: `2026-${String(Math.max(1, 6 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 25 - (i % 15))).padStart(2, '0')}`,
    })),
  },
  {
    id: 8,
    title: '魔女的契约',
    titleEn: 'The Witch\'s Contract',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20fantasy%20Korean%20webtoon%20cover%20showing%20a%20beautiful%20witch%20in%20flowing%20robes%20casting%20spells%20with%20glowing%20runes%2C%20magical%20forest%20setting%2C%20ethereal%20purple%20and%20silver%20lighting%2C%20Korean%20manhwa%20fantasy%20art%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '少女与魔女签订契约，获得了强大的魔法力量，但代价是失去最珍贵的记忆。',
    author: '宋智恩',
    status: '连载中',
    chapters: 72,
    rating: 9.3,
    views: 2300000,
    tags: ['奇幻', '魔法', '冒险', '成长'],
    updateDate: '2026-08-01',
    isHot: false,
    isNew: true,
    isRecommended: true,
    longDescription: '《魔女的契约》是漫画家宋智恩创作的奇幻类漫画。故事中的女主角林素媛因一次意外与传说中的魔女签订了契约，获得了操控元素的魔法力量，但代价是每天都会失去一段记忆。为了找回被遗忘的过往，林素媛踏上了寻找解除契约之法的旅程。作品融合了韩国传统巫俗文化与西方魔法体系，创造出独具特色的世界观。精美的画面和感人至深的故事使其成为韩国奇幻漫画的代表之作。',
    chapters_list: Array.from({ length: 72 }, (_, i) => ({
      num: 72 - i,
      title: `第${72 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 20))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 20))).padStart(2, '0')}`,
    })),
  },
  {
    id: 9,
    title: '我们的季节',
    titleEn: 'Our Season',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20tender%20romance%20Korean%20webtoon%20cover%20showing%20a%20couple%20walking%20under%20cherry%20blossoms%20in%20spring%2C%20soft%20pink%20and%20white%20petals%2C%20dreamy%20atmosphere%2C%20warm%20sunlight%2C%20Korean%20manhwa%20romance%20art%20style&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '青梅竹马的两人，从春夏秋冬到岁岁年年。一段跨越十年的纯爱故事，温暖治愈。',
    author: '韩素英',
    status: '已完结',
    chapters: 52,
    rating: 9.6,
    views: 3500000,
    tags: ['恋爱', '治愈', '青春', '成长'],
    updateDate: '2026-07-28',
    isHot: false,
    isNew: false,
    isRecommended: true,
    longDescription: '《我们的季节》是韩国漫画家韩素英创作的纯爱治愈漫画。故事以四季更迭为线索，讲述了青梅竹马的尹智浩和郑瑞妍从小学到大学的十年时光。作品没有跌宕起伏的戏剧性冲突，而是以细腻的笔触描绘了两个普通人在成长过程中的点点滴滴——春天一起看樱花，夏天在海边嬉戏，秋天在落叶中漫步，冬天在初雪中许愿。正是因为这份平凡与真实，让无数读者在其中看到了自己的影子，被誉为"最治愈的韩国恋爱漫画"。',
    chapters_list: Array.from({ length: 52 }, (_, i) => ({
      num: 52 - i,
      title: `第${52 - i}话`,
      date: `2026-${String(Math.max(1, 7 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 15))).padStart(2, '0')}`,
    })),
  },
  {
    id: 10,
    title: '格斗天王',
    titleEn: 'Fight King',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20fierce%20martial%20arts%20fighting%20Korean%20webtoon%20cover%20showing%20a%20muscular%20fighter%20in%20boxing%20ring%20with%20intense%20expression%2C%20dramatic%20spotlight%2C%20sweat%20and%20motion%2C%20dynamic%20angle%2C%20Korean%20manhwa%20action%20style&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '从街头混混到格斗冠军，一个少年的热血格斗之路。拳拳到肉的真实打斗，燃到爆！',
    author: '张赫俊',
    status: '连载中',
    chapters: 110,
    rating: 9.1,
    views: 2900000,
    tags: ['动作', '格斗', '热血', '竞技'],
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: false,
    longDescription: '《格斗天王》是韩国漫画家张赫俊的热血格斗漫画。主人公刘在赫原本是首尔街头的一个小混混，因一次意外被格斗教练发现其惊人的格斗天赋，从此走上了职业格斗选手的道路。作品详细展现了混合武术的各类技巧和战术，同时刻画了主角在追求梦想过程中面临的挑战与成长。逼真的打斗画面和热血的剧情让这部作品成为韩国动作漫画中的一匹黑马。',
    chapters_list: Array.from({ length: 110 }, (_, i) => ({
      num: 110 - i,
      title: `第${110 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 30))).padStart(2, '0')}`,
    })),
  },
  {
    id: 11,
    title: '美食大冒险',
    titleEn: 'Food Adventure',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20colorful%20food-themed%20comedy%20Korean%20webtoon%20cover%20with%20exaggerated%20delicious%20dishes%20and%20funny%20character%20reactions%2C%20vibrant%20warm%20colors%2C%20playful%20style%2C%20Korean%20manhwa%20comedy%20food%20theme&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '一个热爱美食的吃货少女，立志吃遍全韩国的美食。搞笑的美食评论和夸张的反应让人忍俊不禁。',
    author: '朴美英',
    status: '连载中',
    chapters: 84,
    rating: 8.9,
    views: 1800000,
    tags: ['搞笑', '美食', '日常', '治愈'],
    updateDate: '2026-08-02',
    isHot: false,
    isNew: true,
    isRecommended: false,
    longDescription: '《美食大冒险》是漫画家朴美英的美食搞笑漫画。女主角金多喜是一名美食博主，她的梦想是吃遍韩国每一个角落的美食。每一话都会介绍一种韩国特色美食，从街边小吃到高级料理，配合金多喜夸张搞笑的表情和入木三分的美食点评，让读者既解馋又解压。作品还穿插了金多喜与餐厅老板、其他美食家之间的趣味互动，轻松愉快的节奏适合所有年龄段的读者。',
    chapters_list: Array.from({ length: 84 }, (_, i) => ({
      num: 84 - i,
      title: `第${84 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 25))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 25))).padStart(2, '0')}`,
    })),
  },
  {
    id: 12,
    title: '末日后的一封信',
    titleEn: 'Letter After Apocalypse',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20post-apocalyptic%20drama%20Korean%20webtoon%20cover%20showing%20a%20lone%20survivor%20writing%20a%20letter%20in%20ruined%20cityscape%2C%20warm%20sunlight%20breaking%20through%20clouds%2C%20hopeful%20yet%20melancholy%20mood%2C%20Korean%20manhwa%20drama%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '末日之后，幸存者们在废墟中重建文明。一封来自过去的信，改变了一个少年的命运。',
    author: '郑宇成',
    status: '连载中',
    chapters: 56,
    rating: 9.5,
    views: 4100000,
    tags: ['剧情', '末世', '科幻', '人性'],
    updateDate: '2026-08-04',
    isHot: true,
    isNew: true,
    isRecommended: true,
    longDescription: '《末日后的一封信》是韩国漫画家郑宇成的末世科幻题材作品。故事设定在一次全球性灾难发生三年后，人类文明几乎毁灭殆尽。少年崔俊赫在废墟中偶然发现了一封"来自过去的信"——那是他在灾难前写给未来自己的信。这封信成为了他在末世中坚持下去的动力，也引导他踏上寻找其他幸存者的旅程。作品在末世背景下探讨了人性、希望与生存的意义，深刻而富有哲思。',
    chapters_list: Array.from({ length: 56 }, (_, i) => ({
      num: 56 - i,
      title: `第${56 - i}话`,
      date: `2026-${String(Math.max(1, 8 - Math.floor(i / 15))).padStart(2, '0')}-${String(Math.max(1, 30 - (i % 15))).padStart(2, '0')}`,
    })),
  },
];

export const faqs = [
  {
    question: '妖精动漫网站上的韩国漫画都是免费的吗？',
    answer: '是的，妖精动漫上的所有韩国漫画均免费提供阅读。我们致力于为广大韩漫爱好者打造一个无门槛的阅读平台，所有作品均可免费畅读，无需付费订阅。',
  },
  {
    question: '什么是下拉式漫画阅读模式？',
    answer: '下拉式漫画阅读模式是一种专为移动端和网页端优化的漫画呈现方式。与传统翻页模式不同，下拉式模式将漫画所有画面纵向排列，读者只需向下滑动即可连续阅读，无需点击翻页按钮，阅读体验更加流畅自然。',
  },
  {
    question: '妖精动漫上的漫画有删减吗？',
    answer: '妖精动漫坚持提供无删减版本的韩国漫画。我们尊重原作者的创作意图，所有漫画均保持原版内容完整，不进行任何形式的删减或修改，让读者能够欣赏到原汁原味的韩漫作品。',
  },
  {
    question: '如何找到我想看的特定漫画？',
    answer: '您可以通过网站顶部的搜索功能输入漫画名称进行搜索，也可以通过分类页面按类型（如恋爱、奇幻、动作等）筛选漫画。此外，首页的推荐区和热门榜单也能帮助您发现优质漫画。',
  },
  {
    question: '网站上的漫画多久更新一次？',
    answer: '不同漫画的更新频率有所不同。热门连载漫画通常每周更新1-2话，部分作品可能会根据作者的更新计划有所调整。您可以在每部漫画的详情页查看最新更新时间。',
  },
  {
    question: '妖精动漫支持手机阅读吗？',
    answer: '当然支持！妖精动漫采用响应式设计，完美适配手机、平板和电脑等各种设备。特别优化的下拉式阅读模式在手机上也能提供流畅舒适的阅读体验。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20Korean%20style%20anime%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20simple%20background%2C%20soft%20colors&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '在妖精动漫看韩漫已经一年多了，画质清晰、更新又快，最重要的是完全免费！推荐给了好多朋友。',
    rating: 5,
  },
  {
    name: '漫画狂热者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20Korean%20style%20anime%20boy%20avatar%20with%20glasses%20and%20dark%20hair%2C%20simple%20background%2C%20clean%20illustration&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '下拉式阅读体验太棒了，一口气能看好几话。分类也很全，想看的韩漫基本都能找到。',
    rating: 5,
  },
  {
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20Korean%20style%20anime%20girl%20avatar%20with%20long%20black%20hair%2C%20gentle%20expression%2C%20simple%20background%2C%20soft%20illustration&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '无删减版本真的太良心了，很多在其他平台被删减的内容在这里都能看到完整版。',
    rating: 5,
  },
];